export default __webpack_public_path__ + "static/media/Video_step1.ecd9ca99.mp4";